import { registerQuery } from 'data-fetching-client';
import { getDomains } from '../api/DomainsAPI';
export const FETCH_DOMAINS = registerQuery({
  fieldName: 'domains',
  fetcher: getDomains
});